import Button from "../Button";

interface CommentTagProps {
    title: string;
    date: string;
    subTitle: string;
    comment?: string;
    score?: string;
    type: string;
    status?: boolean;
}

function CommentTag(props: CommentTagProps) {
    const { title, date, subTitle, score, type, comment, status } = props;
    const percentScore = (Number(score) / 10) * 100 + "%";
    const checkStatus = type === "test" ? percentScore : type === "homework" && status === true ? "Đã hoàn thành" : "Chưa hoàn thành";
    const handleClick = () => {

    }
    return (<div
        className="mt-[30px] w-full lg:max-w-[32%] bg-white rounded-box shadow-default p-[25px] flex flex-col items-start 
               transition-transform duration-300 hover:-translate-y-2 hover:shadow-lg"
    >
        <div className="flex justify-between items-center w-full">
            <h3 className="text-bold text-[20px] font-[600]">{title}</h3>
            <p className="text-title text-[15px]">{date}</p>
        </div>
        <div className="mt-[15px] text-left">
            {subTitle}
        </div>
        {type === "test" ? (
            <div className="mt-[15px] w-full h-[8px] bg-gray-200 rounded-full overflow-hidden">
                <div
                    className="h-full bg-green-500 rounded-full transition-all duration-500"
                    style={{ width: `${percentScore}` }}
                ></div>
            </div>) : (
            <div className="mt-[15px] w-full text-left">
                <span className="text-bold font-[700] text-left inline-block">Nhận xét của giáo viên: &nbsp;</span>{comment}
            </div>
        )}
        <div className="mt-[15px] flex justify-between items-center w-full">
            <Button label="Xem chi tiết" styleButton="max-w-[146px] max-h-[45px]" onClick={() => handleClick} />
            <span>{checkStatus}</span>
        </div>
    </div>);
}

export default CommentTag;